var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"container",attrs:{"id":"header"}},[(_vm.logoVisible)?_c('Logo',{staticClass:"partner-logo",attrs:{"src":_vm.logoSrc}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }